/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useRef,
  useContext,
  useEffect,
  useLayoutEffect,
} from 'react';
import { css as _css } from 'emotion';
import { css, jsx } from '@emotion/core';
import { colors, getButtonFocus } from 'styles/variables';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';

import getCurrentBlock from 'services/apiHelpers/getCurrentBlock';
import getBlockById from 'services/apiHelpers/getBlockById';
import { interactionContext } from './interactionContext';
import checkReturnToInteractionEditing from 'services/checkReturnToInteractionEditing';
import isIE from 'services/isIE';
import isiOS from 'services/isiOS';
import Modal from 'components/UI/Modal';
import Feedback from './Feedback';
import pubSub from 'services/pubSub';
import getCurrentLocation from 'services/getCurrentLocation';
import getStore from 'services/getStore';

const store = getStore();

const { lGrey0, lGrey2, lPink } = colors;

const seenSession = {};

const ClickAndRevealSeenTick = ({ width = 16, height = 15, color }) => {
  return (
    <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1">
      <title>Path</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <polyline
          id="Path"
          stroke={color}
          strokeWidth="2"
          transform="translate(7.486953, 6.527846) rotate(6.000000) translate(-7.486953, -6.527846) "
          points="0.886953048 9.1308343 6.78684502 13.1278461 14.086953 -0.0721539421"
        />
      </g>
    </svg>
  );

  return (
    <svg width={width} height={height}>
      <polyline
        style={{
          fill: 'none',
          stroke: color,
          strokeWidth: 2,
        }}
        points={`0,${height / 2} ${width / 2},${height} ${width},0`}
      />
    </svg>
  );
};

const ClickAndReveal = ({
  // backgroundColor,
  // textColor,
  children,
  // width = 200,
  // height = 200,
  // borderRadius = 10,
  // borderColor = lGrey2,
  // layout = 'column',
  ...props
}) => {
  //

  const [showFeedback, setShowFeedback] = useState(false);

  const [imageText, text, content] = children;

  // const { width=200, height=200, borderRadius, borderColor, layout = 'column' } = props;

  const context: any = useContext(interactionContext);

  const { id, updateClickAndRevealSeen } = context;

  if (!seenSession[id]) {
    seenSession[id] = {};
  }

  const [seen, setSeen] = useState(
    seenSession[id] ? seenSession[id][props.id] : false
  );

  const {
    backgroundColor,
    clickAndRevealPanelTextColor,
    includeLabel = true,
    clickAndRevealLabelTextColor,
    showSeenState = true,
    clickAndRevealShowSeenStateBackgroundColor,
    clickAndRevealShowSeenStateTickColor,
    // children,
    width,
    height,
    panelOutline,
    borderRadius,
    borderColor,
    layout,
    useGlobalNavigation = false,
    globalNavigation = {},
  } = context.props;

  // console.log(props);

  const panelImg = useRef(null);

  const onClose = () => {
    window.dev() && checkReturnToInteractionEditing(true);
    setShowFeedback(!showFeedback);
  };

  // console.log(props.id);

  useEffect(() => {
    const pS = pubSub.subscribe(
      `CLICK_AND_REVEAL_FEEDBACK_${props.parentId}`,
      $ => {
        // console.log($.id, id);
        if ($.id !== props.id) {
          if ($.eventType === 'click') {
            setShowFeedback(false);
          }
          return;
        }

        switch ($.eventType) {
          case 'mouseOver': {
            // console.log('hilite_on', id);
            panelImg.current.style.boxShadow = `0 0 0 2px ${lPink}`;
            return;
          }
          case 'mouseOut': {
            // console.log('hilite_off', id);
            panelImg.current.style.boxShadow = null;
            return;
          }
          case 'click': {
            setShowFeedback(true);
            return;
          }
        }
      }
    );

    return () => pS();
  }, []);

  useEffect(() => {
    if (!useGlobalNavigation) {
      return;
    }

    const isSeen = seenSession[id][props.id];
    if (isSeen) {
      updateClickAndRevealSeen(props.id);
    }
  });

  const returnToLastFocused = () => {
    // get the element we just had focus on
    const findLastFocused = setInterval(() => {
      //
      const lastFocused: any = document.querySelector(`#panel-img-${props.id}`);

      if (lastFocused) {
        clearInterval(findLastFocused);
        lastFocused.focus();
      }
    }, 125);
  };

  // fixing this up
  // was the below
  // height: ${!!includeLabel ? '100%' : `${height}px`};
  // changed to : height: ${!!!includeLabel ? `${height}px` : 'auto'};
  // but. this is easier to read
  let useFixedHeightOrAuto = 'auto';
  if (includeLabel === 0) {
    useFixedHeightOrAuto = `${height}px`;
  }

  // height: ${useFixedHeightOrAuto};

  // height: ${includeLabel === 1 ? 'auto' : height + 'px'};

  return (
    <_>
      <div
        css={css`
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          flex-shrink: 0;
          width: ${width}px;

          //

          height: ${useFixedHeightOrAuto};

          margin: 20px;
          cursor: pointer;
        `}
        onClick={() => {
          if (window.dev() && useGlobalNavigation) {
            if (store.getState().focusedNodeId !== id) {
              setCurrentBlock({ id });
              // return;
            }

            pubSub.publish('SET_CLICK_AND_REVEAL_GLOBAL_NAVIGATION_PANEL', {
              panelId: props.id,
            });

            return;
          }
          //

          //
          if (useGlobalNavigation) {
            const location = globalNavigation[props.id];
            if (location) {
              // need a check
              // are we in the same topic ? then this needs to happen : setSeen(. . .
              // else it gets set when we return. reRender
              const topicLocation = location.split('/')[0];
              const currentTopicLocation = getCurrentLocation().split('/')[0];

              if (topicLocation === currentTopicLocation) {
                setTimeout(() => {
                  setSeen((seenSession[id][props.id] = true));
                }, 300);
              } else {
                seenSession[id][props.id] = true;
              }

              // console.log(
              //   location.split('/')[0] === getCurrentLocation().split('/')[0]
              // );

              // set history
              // window.locationHistory = getCurrentLocation();

              window.location.hash = location;
            }
            return;
          }

          updateClickAndRevealSeen(props.id);

          if (!seenSession[id][props.id]) {
            setTimeout(() => {
              setSeen((seenSession[id][props.id] = true));
            }, 300);
          }

          setShowFeedback(!showFeedback);
        }}
      >
        <div
          ref={panelImg}
          id={`panel-img-${props.id}`}
          css={css`
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            left: 0;
            top: 0;
            width: ${width}px;
            height: ${height}px;
            ${imageText.props.child === 0 &&
              `
          padding: ${window.dev() ? '10px' : '20px'};
        `}

            white-space: pre-wrap;
            overflow-wrap: break-word;

            background-color: ${backgroundColor || 'transparent'};
            color: ${clickAndRevealPanelTextColor};

            // border: 1px solid ${backgroundColor};
            // border-radius: ${borderRadius}px;

            ${
              panelOutline
                ? `
            border: 1px solid ${backgroundColor};
            border-radius: ${borderRadius}px;
            `
                : `border-radius: ${borderRadius}px;`
            }
          
            overflow: hidden;

            * {
              line-height: 1.2em;
            }

            transition: opacity 0.2s;

            &:hover {
              // transition: opacity: 0.2s;
              opacity: 0.8;
            }

            &:focus {
              ${getButtonFocus(backgroundColor || lGrey0)}
            }

            //double up needed for editing. . .
            * div {
              color: ${clickAndRevealPanelTextColor};
            }

            
          `}
          onKeyUp={
            window.dev()
              ? null
              : e => {
                  if (![' ', 'Enter'].includes(e.key)) {
                    return;
                  }

                  // if (!seenSession[id][props.id]) {
                  //   setTimeout(() => {
                  //     setSeen((seenSession[id][props.id] = true));
                  //   }, 300);
                  // }
                  // //

                  // updateClickAndRevealSeen(props.id);
                  //
                  setShowFeedback(!showFeedback);
                }
          }
          tabIndex={0}
        >
          {imageText}
        </div>
        {!!includeLabel && (
          <div
            css={css`
              display: flex;
              justify-content: center;
              color: ${clickAndRevealLabelTextColor};
              width: 100%;
              margin: ${window.dev() ? height : height + 15}px 0 0 0;

              //double up needed for editing. . .
              * div {
                color: ${clickAndRevealLabelTextColor};
              }
            `}
          >
            {text}
          </div>
        )}

        {!!showSeenState && (window.dev() || seen) && (
          <div
            css={css`
              position: absolute;
              display: flex;
              justify-content: center;
              align-items: center;
              right: -22px;
              top: -22px;
              width: 44px;
              height: 44px;
              background: ${clickAndRevealShowSeenStateBackgroundColor ||
                lGrey0};
              // border: 1px solid ${clickAndRevealShowSeenStateBackgroundColor ||
                '#000'};
              border-radius: 50%;

              pointer-events: none;
            `}
          >
            {/* <i
              className="fa fa-check"
              css={css`
                font-size: 11px;
                color: ${clickAndRevealShowSeenStateTickColor || '#fff'};
              `}
            ></i> */}
            <ClickAndRevealSeenTick
              color={clickAndRevealShowSeenStateTickColor || '#fff'}
            />
          </div>
        )}
      </div>

      {showFeedback && (
        <Modal
          onClose={() => {
            if (!seenSession[id][props.id]) {
              setSeen((seenSession[id][props.id] = true));
            }
            //
            updateClickAndRevealSeen(props.id);

            returnToLastFocused();
            onClose();
          }}
        >
          {React.cloneElement(content, {
            layout,
            onClose() {
              if (!seenSession[id][props.id]) {
                setSeen((seenSession[id][props.id] = true));
              }
              //
              updateClickAndRevealSeen(props.id);

              returnToLastFocused();
              onClose();
            },
          })}
        </Modal>
      )}
    </_>
  );
};

export default ClickAndReveal;
